import SaleschannelInfoModal from './saleschannel-info-modal.vue'
export default SaleschannelInfoModal
